export class OAuthParameters {
  /***
   * Client Id
   */
  public clientId: string;

  /***
   * Redirect URI
   */
  public redirectUri: string;

  /***
   * Scope
   */
  public scope: string;

  /***
   * User defined state
   */
  public state: string;

  constructor(clientId: string, redirectUri: string, scope: string, state: string) {
    this.clientId = clientId;
    this.redirectUri = redirectUri;
    this.scope = scope;
    this.state = state;
  }

  /***
   * Basic validation of OAuth 2 params
   */
  public isValid(): boolean {
    if (!this.clientId || this.clientId === '') {
      return false;
    }

    if (!this.redirectUri || this.redirectUri === '') {
      return false;
    }

    if (!this.scope || this.scope === '') {
      return false;
    }

    if (!this.state || this.state === '') {
      return false;
    }

    return true;
  }
}
